import script from "./InformeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./InformeDetail.vue?vue&type=script&setup=true&lang=js"

import "./InformeDetail.vue?vue&type=style&index=0&id=1e85969c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e85969c"]])

export default __exports__